import { createApp } from "vue";
import { MdsConfig } from "@maersk-global/mds-config";
import App from "@/App.vue";
import { getRouter } from "@/router";
import pinia from "@/store/index";
import { setupValidation } from "@/utils/validation";
import msalPlugin from "@/lib/vue-msal/plugin";
import { getMsalConfig } from "@/msal";

MdsConfig.iconsDynamicImportPath = "./";

const app = createApp(App);
app.use(pinia);
app.use(getRouter());

if (import.meta.env.DEV && !import.meta.env.VITE_E2E) {
  MdsConfig.iconsDynamicImportPath = "../../";
}

setupValidation();

(async () => {
  if (import.meta.env.DEV && !import.meta.env.VITE_MSAL_CLIENT_ID) {
    const { default: mockMsalPlugin } = await import("@/lib/vue-msal/mock-plugin");
    app.use(mockMsalPlugin);
  } else {
    app.use(
      msalPlugin,
      getMsalConfig(
        import.meta.env.VITE_MSAL_CLIENT_ID,
        import.meta.env.VITE_MSAL_AUTHORITY,
        import.meta.env.VITE_MSAL_TOKEN_SCOPE
      )
    );
  }

  app.mount("#maersk-app");
})();
